
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.874 17.5V14c0-.496.171-.911.514-1.247a1.704 1.704 0 011.236-.503H5.49c.291 0 .568.073.83.219.263.146.475.343.635.59a4.514 4.514 0 001.564 1.335c.62.32 1.28.481 1.98.481.715 0 1.382-.16 2.002-.481a4.317 4.317 0 001.542-1.335c.19-.247.412-.444.667-.59.255-.146.521-.219.798-.219h2.866c.496 0 .912.168 1.247.503.335.336.503.751.503 1.247v3.5h-6.125v-1.99a5.956 5.956 0 01-3.5 1.115c-.627 0-1.24-.098-1.837-.295a6.157 6.157 0 01-1.663-.842V17.5H.874zm9.625-3.5c-.554 0-1.08-.127-1.575-.383a3.566 3.566 0 01-1.247-1.06 2.769 2.769 0 00-.93-.865 2.415 2.415 0 00-1.214-.317c.321-.54 1-.966 2.035-1.28 1.035-.313 2.012-.47 2.931-.47s1.896.157 2.931.47c1.036.314 1.714.74 2.035 1.28-.423 0-.824.106-1.204.317-.379.212-.692.5-.94.864-.32.467-.73.824-1.225 1.072a3.52 3.52 0 01-1.597.372zm-7-2.625c-.73 0-1.349-.255-1.86-.765a2.531 2.531 0 01-.765-1.86c0-.744.255-1.367.766-1.87a2.55 2.55 0 011.859-.755c.744 0 1.367.252 1.87.755.503.503.755 1.126.755 1.87a2.55 2.55 0 01-.755 1.86c-.503.51-1.126.765-1.87.765zm14 0c-.73 0-1.349-.255-1.86-.765a2.531 2.531 0 01-.765-1.86c0-.744.255-1.367.766-1.87a2.55 2.55 0 011.859-.755c.744 0 1.367.252 1.87.755.503.503.755 1.126.755 1.87a2.55 2.55 0 01-.755 1.86c-.503.51-1.126.765-1.87.765zm-7-2.625c-.73 0-1.349-.255-1.86-.766a2.531 2.531 0 01-.765-1.859c0-.744.255-1.367.766-1.87a2.55 2.55 0 011.859-.755c.744 0 1.367.252 1.87.755.504.503.755 1.126.755 1.87a2.55 2.55 0 01-.755 1.86c-.503.51-1.126.765-1.87.765z","fill":"#00ADA8"}})])
          )
        }
      }
    